export enum Language {
  English = 'English',
  Spanish = 'Spanish',
  Hindi = 'Hindi',
  Mandarin = 'Mandarin',
  French = 'French',
  Arabic = 'Arabic',
  Bengali = 'Bengali',
  Russian = 'Russian',
  Portuguese = 'Portuguese',
  Indonesian = 'Indonesian',
  Urdu = 'Urdu',
  German = 'German',
  Japanese = 'Japanese',
  Marathi = 'Marathi',
  Telugu = 'Telugu',
  Tamil = 'Tamil',
  Turkish = 'Turkish',
  Korean = 'Korean',
  Punjabi = 'Punjabi',
  Thai = 'Thai',
  Swahili = 'Swahili',
}
